import React from "react";
import { RFQ_QuoteSubmissionPage } from "@b2b/ui-components/features/RFQ_QuoteSubmission";
import { useParams, useNavigate } from "react-router-dom";

export default function RFQ_QuoteSubmission() {
  const { id } = useParams();
  const navigate = useNavigate();

  return <RFQ_QuoteSubmissionPage id={id} navigate={navigate} />;
}